import React from 'react';
const { useEffect } = React;

import useRxDispatch from '../../utils/use-rx-dispatch';
import { SessionActionTypes } from '../../types/session';

const Logout: React.FunctionComponent<{}> = () => {
  const dispatch = useRxDispatch();
  useEffect(() => {
    dispatch({ type: SessionActionTypes.SESSION_CLEAR_TOKEN });
    window.location.href = '#/login';
  }, []);

  return null;
};

export default Logout;
